export enum OrderInternalTypeEnum {
    Undefined = -1,
    Input,
    StopLoss,
    StopGain
}